<template>
	<div class="aboutUs">
		<!-- pc -->
		<div class="content1200">
			<div class="minW">
				<div class="secondPage_main">
					<div class="secondPage_main_fl">
						<div class="menu">
							<div class="menu_item"
								:class="[item.id == id ? `wui-color-${themeColor}` : '', `wui-hover-color-${themeColor}`]"
								v-for="item in columnList" :key="item.id" @click="tab(item)">
								{{ item.moduleName }}
							</div>
						</div>
					</div>
					<div class="secondPage_main_fr" v-loading="loading">
						<div v-if="moduleType == '0'" class="content">
							<!-- <div v-html="moduleCont"></div> -->

							<iframe 
                                    :srcdoc="iframeContent"
                                    sandbox="allow-same-origin"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    width="100%"
                                    height="100%"
                                    frameborder="0"
									@load="adjustIframeHeight"
                  v-if="isiframeShow"
                  ref="myIframe"
                                ></iframe>
						</div>
						<div class="mediaType" v-if="moduleType == '1' || moduleType == '2'">
							<div class="ul">
								<div class="li" v-for="item in piclist" :key="item.id">
									<div class="img" v-if="moduleType == '1'">
										<el-image :src="commenUrl + item.url" style="width:100%;height: 100%;">
											<template #error>
												<div class="image-slot"></div>
											</template>
										</el-image>
									</div>
									<div class="img" v-else>
										<video :src="commenUrl + item.url" controls="controls" :autoplay="false"
											style="width:100%;height: 100%;"></video>
									</div>
									<div class="txt">
										<div class="txt-1">
											<div class="title ellipsis">{{ item.title }}</div>
											<div class="remarks ellipsis">{{ item.remarks }}</div>
										</div>
										<div class="txt-2">{{ item.uploadDate }}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="linkType" v-if="moduleType == '8'">
							<iframe :src="moduleCont" frameborder="0" style="width: 100%; height: 100%"
								id="iframeid"></iframe>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script setup>
import { getCurrentInstance, ref, computed, watch,onMounted,nextTick } from "vue";
import { useRoute } from "vue-router";
const props = defineProps({
	themeColor: {
		type: String,
		default: 'blue'
	}
})
const { proxy } = getCurrentInstance();
const route = useRoute();
let id = ref(route.query.id);

watch(() => route.query.id, (newValue, oldValue) => {
	if (route.path == '/aboutUs') {
		id.value = newValue;
		getinfo()
	}
});
const tab = (item) => {
	if (item.moduleType == '9') {
		proxy.tool.openWindow(item.moduleCont);
	} else {
    isiframeShow.value=false;
		id.value = item.id;
		getinfo();
	}

}
let moduleCont = ref("");
let moduleType = ref("");
let loading = ref(false);
let isiframeShow=ref(false);
const getinfo = () => {
	loading.value = true;
	proxy.$request({
		url: 'INDUSTRYMODULEMAGE_FINDINFO',
		method: 'post',
		data: {
			"portalType": proxy.getConfig().portalType,
			"id": id.value
		}
	}).then((res) => {
		if (res.data.code == "000") {
			moduleCont.value = res.data.result.moduleCont;
			moduleType.value = res.data.result.moduleType;
			let moduleId = res.data.result.id;
			if (moduleType.value == '1' || moduleType.value == '2') {
				getContlist(moduleType.value, moduleId);
			}
      if(moduleType.value=='0'){
        isiframeShow.value=true;
        processMediaContent();
      }
		}
		loading.value = false;
	}).catch((err) => {
		console.log(err);
		loading.value = false;
	})
}

let columnList = ref([]);
const getColumnList = () => {
	proxy.$request({
		url: 'INDUSTRYMODULEMAGE_FINDPAGELIST',
		method: 'post',
		data: {
			"portalType": proxy.getConfig().portalType,
			"moduleCategory": "1",
			"pageInfo": {
				"pageNo": 1,
				"pageSize": 20
			},
		}
	}).then((res) => {
		if (res.data.code == "000") {
			columnList.value = res.data.result.list;
		}
	}).catch((err) => {
		console.log(err);
	})
}
getColumnList();
let piclist = ref([]);
const getContlist = (moduleType, moduleId) => {//获取图片列表 或者视频列表
	let type = moduleType == '1' ? '0' : '1';
	proxy.$request({
		url: 'INDUSTRYLMODULECONTENT_FINDLIST',
		method: 'post',
		data: {
			"portalType": proxy.getConfig().portalType,
			"moduleType": type,
			"moduleId": moduleId,
			"pageInfo": {
				"pageNo": 1,
				"pageSize": 20
			},
		}
	}).then((res) => {
		if (res.data.code == "000") {
			piclist.value = res.data.result;
		}
	}).catch((err) => {
		console.log(err);
	})
}
// 处理富文本内容中的图片、视频和段落样式
const myIframe = ref(null);
const processMediaContent = () => {
  nextTick(() => {
    if (myIframe.value) {
    myIframe.value.addEventListener('load', () => {
    
    const iframeWindow = myIframe.value.contentWindow;
    const container = iframeWindow.document;
    //const container = iframeDocument.querySelector('body');
    console.log(container)
    if (container) {
      const maxWidth = 100;
      
      // 处理普通图片
      const images = container.querySelectorAll('img:not([attr-src])');
      console.log(images)
      console.log(maxWidth)
      images.forEach(img => {
        img.style.maxWidth = `${maxWidth}%`;
        img.style.height = 'auto';
        img.style.display = 'block';
        img.style.margin = '10px auto';
      });
      
      // 特别处理带有attr-src属性的视频链接
      const videoImgTags = container.querySelectorAll('img[attr-src]');
      videoImgTags.forEach(img => {
        const videoUrl = img.getAttribute('attr-src');
        // 检查是否为视频文件
        if (videoUrl && (videoUrl.endsWith('.mp4') || videoUrl.endsWith('.mov') || videoUrl.endsWith('.avi'))) {
          // 创建视频元素替换图片元素
          const videoElement = document.createElement('video');
          videoElement.controls = true;
          videoElement.preload = 'metadata';
          videoElement.style.maxWidth = `${maxWidth}%`;
          videoElement.style.height = 'auto';
          videoElement.style.display = 'block';
          videoElement.style.margin = '10px auto';
          
          const sourceElement = document.createElement('source');
          sourceElement.src = videoUrl;
          sourceElement.type = 'video/mp4';
          
          videoElement.appendChild(sourceElement);
          
          // 添加不支持视频的提示
          const fallbackText = document.createElement('p');
          fallbackText.textContent = '抱歉，您的浏览器不支持 HTML5 视频播放。';
          videoElement.appendChild(fallbackText);
          
          // 替换元素
          img.parentNode.replaceChild(videoElement, img);
        } else {
          // 不是视频的话，仍然按普通图片处理
          img.style.maxWidth = `${maxWidth}%`;
          img.style.height = 'auto';
          img.style.display = 'block';
          img.style.margin = '10px auto';
        }
      });
      
      // 确保所有视频元素也被正确调整大小
      const videos = container.querySelectorAll('video');
      videos.forEach(video => {
        video.style.maxWidth = `${maxWidth}%`;
        video.style.height = 'auto';
        video.style.display = 'block';
        video.style.margin = '10px auto';
      });
      
      // 处理段落样式
      const paragraphs = container.querySelectorAll('p');
      paragraphs.forEach(p => {
        // 应用样式到所有段落
        p.style.margin = '10px 0';
        p.style.lineHeight = '1.6';
        p.style.wordWrap = 'break-word';
        p.style.color = '#333333';
        p.style.fontSize = '14px';
        p.style.textIndent = '2em';
      });
    }
   
    })
   }
  });
};

// 组件挂载后处理媒体内容
onMounted(() => {
  getinfo();
  // 窗口大小改变时重新调整媒体大小
  window.addEventListener('resize', processMediaContent);
});
const iframeContent = computed(() => {
    return moduleCont.value
})
// 方法：调整iframe高度
const adjustIframeHeight = (event) => {
  
	const iframe = event.target; // 获取触发事件的 iframe 元素
	try {
		// 关键步骤：获取内部文档高度并设置给 iframe
		const body = iframe.contentWindow.document.body;
		const html = iframe.contentWindow.document.documentElement;
		// 为了更精确地获取整个文档的高度，取 scrollHeight 和 offsetHeight 的最大值
		const height = Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight);
		iframe.style.height = height + 'px';
    console.log('触发了2',height)
	} catch (e) {
		// 理论上同源 srcdoc 不会抛出异常，此处捕获仅为保险
		console.error('调整 iframe 高度失败:', e);
	}
};

</script>

<style lang="less" scoped>
.aboutUs {
	background-color: #f6f6f6;

	.ellipsis {
		width: 100%;
		white-space: nowrap;
		/* 不换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略号 */
	}

	.content1200 {
		.minW {
			width: 1200px;
			margin: 0 auto
		}

		.secondPage_main {
			display: flex;
      margin-top: 20px;
			.secondPage_main_fl {
				width: 233px;
				min-height: 493px;
				margin-right: 20px;
				background-color: #ffffff;

				.menu {
					.menu_item {
						line-height: 44px;
						padding-left: 44px;
						font-size: 16px;
						cursor: pointer;
					}

				}
			}

			.secondPage_main_fr {
				min-width: 907px;
				flex: 1;
				padding: 20px;
				background-color: #fff;
				display: flex;
				min-height: calc(100vh - 70px);
				// overflow-y: scroll;
				.content{
					width: 100%;
				}
				.mediaType {
					width: 100%;
					overflow: hidden;

					.ul {
						width: 1214px;

						.li {
							float: left;
							width: 216px;
							margin-right: 14px;
							margin-bottom: 14px;
							border: 1px solid #f7f7f7;

							.img {
								width: 216px;
								height: 162px;
								background-color: #d8d8d8;
							}

							.txt {
								padding: 14px;
								background-color: #fff;
								font-family: PingFangSC-Regular;
								font-size: 14px;
								font-weight: normal;

								.txt-1 {
									display: flex;
									align-items: center;
									justify-content: space-between;
									line-height: 25px;
									margin-bottom: 6px;

									.title {
										width: 145px;
										font-family: PingFangSC-Semibold;
										font-size: 14px;
									}

									.remarks {
										flex: 1;
										color: #666666;
										text-align: right;
									}
								}

								.txt-2 {
									color: #999999;
								}
							}
						}
					}
				}

				.linkType {
					width: 100%;
					height: 100vh;
				}
			}
		}
	}
}

@media (min-width: 1680px) {
	.aboutUs {
		.content1200 {
			.minW {
				width: 1600px;
			}
		}
	}
}
</style>